import type { DatasetFileDownloadButtonProps } from "./dataset-file-download-button.type";

import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useDatasetDownloadFile } from "@/modules/dataset/dataset-download-file";

import "./dataset-file-download-button.style.less";

const DatasetFileDownloadButton = ({
  dataset,
  ...buttonProps
}: DatasetFileDownloadButtonProps) => {
  const { t } = useTranslation();
  const { loading, downloadFile } = useDatasetDownloadFile(dataset);

  const onClick = () => {
    downloadFile();
  };

  return (
    <Button
      icon={<DownloadOutlined />}
      className="dataset-file-download-button"
      data-testid="dataset-file-download-button"
      {...buttonProps}
      onClick={onClick}
      loading={loading}
    >
      {t("global:downloadFile", { fileName: dataset.name })}
    </Button>
  );
};

export default DatasetFileDownloadButton;
